<template>
  <div class="close__btn" :class="classes">
    <svg class="" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="64px" height="64px" @click="pushTheButton()"
    @mouseenter="onMouseEnter()"
    @touchstart="onMouseEnter()"
    @mouseleave="onMouseLeave()"
    @touchend="onMouseLeave()">
      <defs>
        <filter filterUnits="userSpaceOnUse" id="Filter_0" x="0px" y="0px" width="64px" height="64px"  >
            <feOffset in="SourceAlpha" dx="0" dy="0" />
            <feGaussianBlur result="blurOut" stdDeviation="3" />
            <feFlood flood-color="rgb(0, 0, 0)" result="floodOut" />
            <feComposite operator="atop" in="floodOut" in2="blurOut" />
            <feComponentTransfer><feFuncA type="linear" slope="0.26"/></feComponentTransfer>
            <feMerge>
            <feMergeNode/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      <path class="circle-shadow" filter="url(#Filter_0)" fill-rule="evenodd"  fill="rgb(255, 255, 255)"
       d="M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"/>

      <path class="circle" fill-rule="evenodd"  fill="rgb(255, 255, 255)"
       d="M31.500,10.000 C43.374,10.000 53.000,19.626 53.000,31.500 C53.000,43.374 43.374,53.000 31.500,53.000 C19.626,53.000 10.000,43.374 10.000,31.500 C10.000,19.626 19.626,10.000 31.500,10.000 Z"/>

      <g class="cross" transform="translate(22.5,23.5)">
        <path fill-rule="evenodd"  fill="rgb(255, 54, 0)"
         d="M16.574,13.654 L13.991,16.236 L8.501,10.750 L3.012,16.236 L0.429,13.654 L5.918,8.169 L0.429,2.683 L3.012,0.101 L8.501,5.587 L13.991,0.101 L16.574,2.683 L11.085,8.169 L16.574,13.654 Z"/>
      </g>
    </svg>
  </div>
</template>

<script>
import 'styles/components/close-button.styl'
import Emitter from 'core/Emitter'
import TweenMax from 'gsap'

export default {
  name: 'close-button',
  data () {
    return {
    }
  },

  props: [
    'direction'
  ],

  computed: {
    classes () {
      let c = {}
      c[`close__btn--${this.direction}`] = true

      return c
    }

  },
  mounted () {
    this.addListeners()

    this.circleEl = this.$el.querySelector('.circle')
    this.arrowEl = this.$el.querySelector('.cross')
  },
  beforeDestroy () {
    this.removeListeners()
  },
  methods: {
    addListeners () {
    },

    removeListeners () {
    },

    onMouseEnter () {
      let tl = new TimelineMax()
      tl.to(this.circleEl, 0.5, {
        transformOrigin: '50% 50%',
        scale: 1.4,
        // transformOrigin: '50% 50%',
        ease: Back.easeOut
      }, 'start')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1.15,
        rotation: 90,
        ease: Back.easeOut
      }, 'start')
    },

    onMouseLeave () {
      let tl = new TimelineMax()
      tl.to(this.circleEl, 0.6, {
        transformOrigin: '50% 50%',
        scale: 1,
        ease: Quint.easeOut
      }, 'start')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1,
        rotation: 0,
        ease: Quint.easeOut
      }, 'start')
    },

    pushTheButton () {
      Emitter.emit('SOUND::PLAY_UI_CLICK')
      let tl = new TimelineMax()
      tl.to(this.circleEl, 0.3, {
        transformOrigin: '50% 50%',
        scale: 1.3,
        ease: Sine.easeOut
      }, 'first')
      .to(this.circleEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1.4,
        ease: Quint.easeOut
      }, 'second')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 0.8,
        ease: Quint.easeOut
      }, 'first')
      .to(this.arrowEl, 0.4, {
        transformOrigin: '50% 50%',
        scale: 1.15,
        ease: Quint.easeOut
      }, 'second')
    }

  }
}
</script>



/** WEBPACK FOOTER **
 ** CloseButton.vue?7bd94dfa
 **/